/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/sabotage': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M21.548 12.648h-2.196v-2.196l1.775-1.775L20.45 8l-2.055 2.056v2.873l-5.466 5.466h-2.873L8 20.45l.677.677 1.775-1.775h2.196v2.196l-1.775 1.775.677.677 2.055-2.057V19.07l5.465-5.464h2.873L24 11.55l-.678-.677z"/><path pid="1" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
